import React from 'react';
import { render } from 'react-dom';

import 'vendor:../core/dist/vendors~main.index.js';
import 'vendor:../modules/dist/vendors~main.index.js';
import 'vendor:../ui-kit/dist/vendors~main.css';
import 'vendor:../ui-kit/dist/vendors~main.index.js';
import 'vendor:../modules/dist/vendors~main.index.js';

import Main from './Main';

require('./globals');

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
    .then(function(registration) {
      console.log('Registration successful, scope is:', registration.scope);
    })
    .catch(function(err) {
      console.log('Service worker registration failed, error:', err);
    });
}

export default render(<Main />, document.getElementById('root'));
